<template>
  <div class="horizontal layout center relative">
    <div
      class="count-answer"
      v-if="!$store.state.isScreenCapture"
      :class="{
        'has-reaction':
          $store.state.slideActive.type != 'openEnded' &&
          $store.state.slideActive.type != 'multipleChoice' &&
          $store.state.slideActive.type != 'wordCloud' &&
          $store.state.slideActive.type != 'qrcode' &&
          $store.state.slideActive.type != 'pickAnswer' &&
          $store.state.slideActive.type != 'leaderboard',
      }"
      v-hover-intent="{
        onEnter:() => handleHoverOnTheme('in'),
        onExit: () => handleHoverOnTheme('out'),
        exitDelay: 550,
        interval: 100
      }"
    >
      <i
        class="fas fa-user fa-fw"
        aria-hidden="true"
        :class="{ 'animate__bounceIn animate__animated': userCountAnimation }"
      />
      <span
        class="user-online-status"
        :class="{
          online: $store.state.userOnline > 0,
          'status-border': $store.state.slideActive.textColour == '#313131',
          warning: $store.state.onlineStatus == 2,
          danger: $store.state.onlineStatus == 3,
          'no-change': presentingRightData,
        }"
      />
      <span
        class="ml-0.5 relative"
      >{{ ($store.state.userOnline || 0) | formatTotalPoint }}
        <span
          class="show-limit-online "
          v-if="
            $store.state.plan &&
              $store.state.plan.group != 'white-label' &&
              $store.state.plan.group != 'pro' &&
              !$store.state.sharePresentation"
        >
          <span class="limit-slash">/</span>

          <span class="limit-number" v-if="!presentingRightData">
            {{ planLimit }}
          </span>
          <span class="limit-number" v-if="presentingRightData">
            {{ presentingRightData.limit }}
          </span>
        </span>

      </span>
    </div>
    <div
      class="absolute participant-limit-popup "
      :class="{
        'pro-popup': isProPlan || isWhiteLabel,
      }"
      v-hover-intent="{
        onEnter:() => handleHoverPopup('in'),
        onExit: () => handleHoverPopup('out'),
        exitDelay: 400
      }"
      v-if="isHoverShowParticipantPopup && !isDefaultShowTooltipForFreePlan && !isSharingView"
    >
      <div class="relative wrapper-popup arrow-bottom">
        <div>
          <SectionLive />
        </div>
        <div v-if="!(isProPlan || isWhiteLabel)" class="mt-6 body-live-section">
          <span class="text-base-0">
            Up to  {{ planLimit }} participants
          </span>
          <div
            class="text-primary-100 underline"
            :class="isPreview ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'"
            @click="backToEditorAndOpenModalUpgrade('text link')"
          >
            Upgrade for more
          </div>
        </div>
      </div>
    </div>
    <div
      class="absolute participant-limit-popup animate__bounce animate__fadeInUp"

      style="width: 278px"
      v-if="isDefaultShowTooltipForFreePlan && plan === 'free'"
    >
      <div class="relative wrapper-popup arrow-bottom">
        <aha-icon
          name="close"
          class="close-icon cursor-pointer"
          @click="clickClose"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        />

        <div>
          <SectionLive>
            <template #content>
              Up to {{ planLimit }} can join
            </template>
          </SectionLive>
        </div>
        <div v-if="!(isProPlan || isWhiteLabel)" class="mt-6">
          <aha-button
            :disabled="isPreview"
            variant="success"
            class="custom-button"
            @click="backToEditorAndOpenModalUpgrade('button')"
          >
            Upgrade for more
          </aha-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { setTimeout } from 'timers'
import EventBus from '@/eventBus'
import SectionLive from './SectionLive.vue'
import eventCategories from '@/constant/eventCategories'
import {
  EDIT_MODE, FULL_SCREEN_MODE, SET_CURRENT_SLIDE_MODE, WINDOWED_MODE,
} from '@/vuex/types'
import util from '@/util'

export default {
  components: {
    SectionLive,
  },
  data() {
    return {
      userCountAnimation: false,
      isHoverShowParticipantPopup: false,
      isDefaultShowTooltipForFreePlan: false,
      flagCheckOutsidePopUp: false,
      countQRCodeVisible: 0,
    }
  },
  computed: {
    ...mapGetters(['isTreatmentPlanUpgradeEditor', 'isPresenting', 'planLimit']),
    ...mapState({
      isQRCodeVisible: (state) => state.isQRCodeVisible,
      presentingRightData: (state) => state.presentingRightData,
      plan: (state) => state.currentUser.plan,

    }),
    eventCategory() {
      if (this.isPreview) {
        return eventCategories.PRESENTATION_PREVIEW
      }
      if (this.isPresenting) {
        return eventCategories.PRESENTING_MODE
      }

      return eventCategories.PRESENTATION_EDITOR
    },
    isSharingView() {
      return this.$store.state.sharePresentation
    },
    isPreview: () => {
      // get params in url name isPreview
      const isEmbed = util.getParamValue('embedded')
      return isEmbed === 'true'
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },
  },
  watch: {
    isHoverShowParticipantPopup(val) {
      if (val && !this.isDefaultShowTooltipForFreePlan && !this.isSharingView) {
        util.mixpanelTracking(this.eventCategory, 'Presenter > Hover over participants')
      }
    },
    isPresenting() {
      this.isShowTooltipForFreePlan()
    },
  },
  mounted() {
    this.isShowTooltipForFreePlan()
    const self = this
    EventBus.$on('userOnlineCount', () => {
      if (!self.userCountAnimation) {
        self.userCountAnimation = true
        setTimeout(() => {
          self.userCountAnimation = false
        }, 2000)
      }
    })
  },
  methods: {
    handleHoverPopup(psudo) {
      if (psudo === 'in') {
        this.flagCheckOutsidePopUp = true
      }
      if (psudo === 'out') {
        this.flagCheckOutsidePopUp = false
        this.isHoverShowParticipantPopup = false
      }
    },
    isShowTooltipForFreePlan() {
      if (this.plan !== 'free' || !this.isPresenting || this.isSharingView) {
        this.isDefaultShowTooltipForFreePlan = false
        return
      }
      const isShow = (localStorage.getItem('isUserClosePopupForFreePlan') !== 'true')
      if (isShow) {
        util.mixpanelTracking(this.eventCategory,
          'Participant limit > Show tooltip')
      }
      this.isDefaultShowTooltipForFreePlan = isShow || this.isPreview
    },
    backToEditorAndOpenModalUpgrade(eventLabel) {
      util.mixpanelTracking(this.eventCategory,
        'Presenter > Upgrade for more', eventLabel)
      if (this.isPreview) {
        return
      }
      if (!this.isTreatmentPlanUpgradeEditor) {
        return this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
      }
      this.backToEditor()
      EventBus.$emit('open-modal-upgrade-to-presenting')
    },
    clickClose() {
      localStorage.setItem('isUserClosePopupForFreePlan', 'true')
      this.isDefaultShowTooltipForFreePlan = false
      util.mixpanelTracking(this.eventCategory, 'Participant limit > Close tooltip')
    },

    backToEditor() {
      const mode = this.$store.getters.isFullScreenMode
        ? WINDOWED_MODE
        : FULL_SCREEN_MODE
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, mode)
      if (window.innerWidth > 800) {
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
        if (document.fullscreen && document.exitFullscreen) {
          document.exitFullscreen()
        }
      } else {
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      }
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.$store.state.presentation.id },
      })
    },
    handleHoverOnTheme(psudo) {
      if (psudo === 'in') {
        this.isHoverShowParticipantPopup = true
      }
      if (psudo === 'out' && !this.flagCheckOutsidePopUp) {
        this.isHoverShowParticipantPopup = false
        this.flagCheckOutsidePopUp = false
      }
    },
  },

}
</script>
<style lang="scss" scoped>
.participant-limit-popup{
  font-family: Nunito;
  background:#0a0b19;
  top: 0px;
  left: 100%;
  transform: translate(-93%, -108.5%);
  width: 248px;
  box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.19);
  border:1px solid rgba(255, 255, 255, 0.20);
  border-radius: 14px;
  &.pro-popup{
    transform: translate(-93%, -127%);
    .arrow-bottom::before {
      right: 35px;
    }
  }

}
.close-icon{
  position: absolute;
  top: 12px;
  right: 12px;
    cursor: pointer;
    color: #999999;
    font-size: 14px;
    &:hover {
      color: #707070;
    }
}
.wrapper-popup{
  padding: 20px;
  &::before {
    content: "";
    width: 15px;
    height: 15px;
    transform: rotate(45deg);
    box-shadow: 1px 1px 0px rgba(255, 255, 255, 0.2);
    background:#0a0b19;
    position: absolute;
    z-index: -1;
  }
  /*
  Different arrow positioning
  */

  &.arrow-bottom::before {
    right: 54px;
    bottom: -7px;
  }
  &.arrow-bottom-free::before {
    right: 50px;
    bottom: -7px;
  }
}
.body-live-section{
  font-size: 16px;
}
.custom-button{
  padding-left: 1rem;
  padding-right: 1rem;
}

.count-answer{
  padding: 8px 0px;
}
</style>
